// routes
import { RouterProvider } from 'react-router'
import { router } from './routes'

// ----------------------------------------------------------------------

const App = () => <RouterProvider router={router} />

export default App

/* export default function App() {
	return (
		<MotionLazyContainer>
			<ThemeProvider>
				<ThemeSettings>
					<NotistackProvider>
						<ProgressBarStyle />
						 <ChartStyle />
						<ScrollToTop />
						<AppRoutes />
					</NotistackProvider>
				</ThemeSettings>
			</ThemeProvider>
		</MotionLazyContainer>
	)
}
 */
